import React from 'react';
import Layout from '../layouts/layout';
import DinnerMenuSVG from '../assets/dinner-one-page.svg';

export default () => (
  <Layout>
    <DinnerMenuSVG />
  </Layout>
)
